export default __webpack_public_path__ + "static/media/aq.303b11d3.svg";